// extracted by mini-css-extract-plugin
export default {"header":"mIyqBYDEeqxNAkfznzzU","header__holder":"XEmGjN_E1z_dCUs8Yk6g","header__name":"L59uBLYX6_cLU863UTxw"};